module.exports = __webpack_public_path__ + "img/settings-edit.d3507f5a.svg";